import React, { memo } from "react";
import { Field } from "react-form";

export default memo(({ field, defaultValue }) => (
  <Field field={field} defaultValue={defaultValue}>
    {() => <input type="hidden" defaultValue={defaultValue} />}
  </Field>
));
